<h1>Calendar</h1>
<h2>Conception</h2>
<ul>
	<li>Dionysius Exiguus was a monk who created the Anno Domini (AD) calendar system in 525<small>CE</small>.</li>
	<li>AD (Anno Domini) means: In the year of our lord. Not "After death."</li>
	<li>The Gregorian calendar (current calendar) was implemented in 1582<small>CE</small>.</li>
	<li>Before the Gregorian calendar, there were many different calendars in use. The Julian calendar was the most widely used calendar in the world before the Gregorian calendar.</li>
	<li>The Julian calendar was introduced by Julius Caesar in 45<small>BC</small>. It was a solar calendar with a year length of 365.25 days, which is slightly longer than the actual solar year of approximately 365.2422 days.</li>
	<li>The Gregorian calendar was introduced by Pope Gregory XIII in 1582<small>CE</small> to correct the drift of the Julian calendar with respect to the solar year. The Gregorian calendar has a year length of 365.2425 days, which is more accurate than the Julian calendar.</li>
	<li>The Gregorian calendar is now the most widely used civil calendar in the world.</li>
</ul>
<h3>Other calendars</h3>
<ul>
	<li class="swankyGrid">
	@for (date of dateList(); track $index) {
		<div><small>{{date}}</small></div>
	}
	</li>
</ul>
<h3>Relation to other deities and the days of the week</h3>
<ul>
	<li>Sunday: Sun's day.</li>
	<li>Monday: Moon's day.</li>
	<li>Tuesday: <a [appLink]="'https://en.wikipedia.org/wiki/T%C3%BDr'">Týr's day.</a></li>
	<li>Wednesday: <a [appLink]="'https://en.wikipedia.org/wiki/Odin'">Woden's (Oden) day.</a></li>
	<li>Thursday: <a [appLink]="'https://en.wikipedia.org/wiki/Odin'">Thor's day.</a></li>
	<li>Friday: <a [appLink]="'https://en.wikipedia.org/wiki/Frigg'">Frigg's day.</a></li>
	<li>Saturday: <a [appLink]="'https://en.wikipedia.org/wiki/Saturn_(mythology)'">Saturn's day.</a></li>
</ul>
